import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../store/slicers/apiSlicer.js";
import AppLayout from "../layouts/AppLayout.jsx";

const ContentContact = () => {
  const dispatch = useDispatch();
  const [contactInfo, setContactInfo] = useState([]);
  const [currentLang, setCurrentLang] = useState(
    () => localStorage.getItem("onpr_language") || "fr",
  );

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.contact,
    isLoading: state.apiData?.loading?.contact,
  }));

  useEffect(() => {
    dispatch(fetchApiData({ url: "contact-links", itemKey: "contact" }));
  }, [dispatch]);

  useEffect(() => {
    if (data?.data && Array.isArray(data.data)) {
      setContactInfo(data.data);
    }
  }, [data]);

  const getTitle = () => {
    if (!contactInfo.length) return "";
    // Assuming the first item contains the title fields
    const info = contactInfo[0];
    return currentLang === "fr" ? info.title_fr : info.title_en;
  };

  if (isLoading) {
    return (
      <div className="contact-container">
        <h2 className="section-title">Contact</h2>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="contact-container">
      <h2 className="section-title">{getTitle() || "Contactez-nous"}</h2>

      {!contactInfo.length ? (
        <p>Informations de contact non disponibles</p>
      ) : (
        <div className="table-container">
          <table className="contact-table">
            <thead>
              <tr>
                <th>{currentLang === "fr" ? "Agence" : "Agency"}</th>

                <th>Email</th>
                <th>{currentLang === "fr" ? "Téléphone" : "Phone"}</th>
                <th>{currentLang === "fr" ? "Adresse" : "Address"}</th>
              </tr>
            </thead>
            <tbody>
              {contactInfo.map((contact, index) => (
                <tr key={index}>
                  <td>
                    {currentLang === "fr" ? contact.name_fr : contact.name_en}
                  </td>

                  <td>{contact.email}</td>
                  <td>{contact.phone}</td>
                  <td>
                    {currentLang === "fr"
                      ? contact.address_fr
                      : contact.address_en}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <style jsx>{`
        .contact-container {
          max-width: 1200px;
          margin: 40px auto;
          padding: 0 20px;
        }

        .section-title {
          color: #00a652;
          font-size: 2rem;
          margin-bottom: 20px;
        }

        .table-container {
          overflow-x: auto;
          margin: 20px 0;
        }

        .contact-table {
          width: 100%;
          border-collapse: collapse;
          background: white;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
        }

        .contact-table th,
        .contact-table td {
          padding: 12px 15px;
          text-align: left;
          border-bottom: 1px solid #eee;
        }

        .contact-table th {
          background-color: #00a652;
          color: white;
          font-weight: 600;
        }

        .contact-table tr:last-child td {
          border-bottom: none;
        }

        .contact-table tr:hover td {
          background-color: #f8f8f8;
        }

        @media (max-width: 768px) {
          .contact-table {
            font-size: 14px;
          }

          .contact-table th,
          .contact-table td {
            padding: 8px 10px;
          }
        }
      `}</style>
    </div>
  );
};

const ContactPage = () => (
  <AppLayout>
    <ContentContact />
  </AppLayout>
);

export default ContactPage;
